import type { DecoBuildCtx } from "./define.ts";
import { shade, rand } from "../color.ts";

// A big mossy boulder — one large smooth worn mass with smaller stones leaning
// on it and a moss cap draped over the top (plan 28 stage 4: the rounded art
// style; the boulder is a soft toon stone, not a faceted blob).
// Geometry only — spawn metadata (weight/mapColor/habitat/sway/…) lives in
// content/decos/boulder.json; this build is registered in src/model/coded.ts.
const build: (ctx: DecoBuildCtx) => void = ({ ball, seed }) => {
    const base = shade(0x7a766c, (rand(seed) - 0.5) * 0.2);
    const size = 1.6 + rand(seed + 1) * 1.0;
    const cy = size * 0.46;
    // Main mass: one big squashed ball (rot π/2 + depth<1 flattens the WORLD
    // vertical) reads as a worn boulder; radius ~0.96× the old blob circumradius
    // holds the mass envelope. A fused offset lobe breaks the perfect sphere.
    const mS = seed + 900;
    const R = size * 0.96;
    const depth = 0.78 + rand(mS) * 0.08;                    // 0.78..0.86 vertical squash
    ball(0, cy, 0, R, base, depth, [Math.PI / 2, 0, 0]);
    const la = rand(mS + 1) * Math.PI * 2;
    const lo = R * (0.28 + rand(mS + 2) * 0.24);             // offset, stays within the main
    const lr = R * (0.55 + rand(mS + 3) * 0.22);             // smaller shoulder lobe
    ball(Math.cos(la) * lo, cy + (rand(mS + 4) - 0.35) * R * 0.3, Math.sin(la) * lo, lr, base, depth, [Math.PI / 2, 0, 0]);
    // a few attendant smaller rocks hugging the base
    const count = 1 + Math.floor(rand(seed + 2) * 3);
    for (let i = 0; i < count; i++) {
      const a = rand(seed + i * 8) * Math.PI * 2;
      const s = size * (0.3 + rand(seed + i * 8 + 2) * 0.3);
      const r = size * 0.6 + s * 0.4; // sit against the main mass, not floating off
      const ad = 0.74 + rand(seed + 950 + i * 3) * 0.1;      // 0.74..0.84 squash
      ball(Math.cos(a) * r, s * 0.42, Math.sin(a) * r, s * 0.96, shade(base, (rand(seed + i) - 0.5) * 0.2), ad, [Math.PI / 2, 0, 0]);
    }
    // a low moss patch draped over the top — a flatter squashed ball capping the crown
    ball(0, size * 0.86, 0, size * 0.58, 0x4a7a3a, 0.42, [Math.PI / 2, 0, 0]);
  };

export default build;
